import { Plan } from './deprecated/payment/types';

export enum ChallengePlanId {
  CHALLENGE_WITH_SUPPLEMENTS = 'challenge_with_supplements',
  ONLY_CHALLENGE = 'only_challenge',
  PERSON_COACH = 'personal_coach',
}

export enum ChallengeBundleParamId {
  SIX_MONTHS = '6_months_challenge_bundle',
  THREE_MONTHS = '3_months_challenge_bundle',
  EIGHT_WEEKS = '8_weeks_challenge_bundle',
}

export type ChallengeSelectionParam = ChallengePlanId | ChallengeBundleParamId;

export type ChallengePlan = {
  localId: ChallengeSelectionParam;
  id: string;
  price: number;
  originalPrice?: number;
  descriptionLine1: string;
  descriptionLine2: string;
  isBestValue?: boolean;
  badgeText?: string;
  details?: {
    title: string;
    description?: string;
  }[];
  checkoutPlanId?: string;
  plan?: Plan | null;
  renewalDescription?: string;
};

export interface ShopifyVariant {
  variant_name: string;
  is_protein_flavour: number;
  is_included: number;
}

export interface ChallengeSelectionPreviewItem {
  currentChallengePriceId: string;
  challengePlanType: string;
  scheduledMonths: number | null;
  nextPlan: number;
  nextPlanPriceId: string;
  scheduleStart: string;
}

export interface ChallengeSelectionPreviewResponse {
  currency: string;
  timezone: string;
  today: string;
  preview: ChallengeSelectionPreviewItem[];
}
